import * as React from "react";

import {cn} from "@/lib/utils";

function Input({className, type, ...props}: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "border-transparent placeholder:text-primary/30 hover:border-primary/10 focus-visible:border-primary/30 aria-invalid:border-primary/30 aria-errormessage:not-focus:text-error flex field-sizing-content w-full min-w-0 rounded-md border bg-primary/5 px-2 py-1.5 outline-none disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export {Input};
